import { createAction } from '@wix/communities-blog-client-common';

export const SET_FEED_SEO_TAGS = 'feedSEOTags/SET';

export const setFeedSEOTags = createAction(SET_FEED_SEO_TAGS);
